// import React from 'react';
// import { Outlet } from 'react-router-dom'
// import Sidebar from '../components/Sidebar'

// export default function Layout() {
//     const [sidebarW, setSidebarW] = React.useState(false);

//     const toggleSidebar = () => {
//         setSidebarW(!sidebarW)
//     }

//     return (
//         <div>
//             <Sidebar toggleSidebar={toggleSidebar} />
//             <div style={sidebarW ? { marginTop: 50, paddingLeft: 90, paddingTop: 30, paddingRight: 10 } : { marginTop: 50 }} id="main-content" className={sidebarW ? "" : 'container-fluid mb-5'}>
//                 <Outlet />
//             </div>
//         </div >
//     )

// }

import React from 'react';
import { Outlet } from 'react-router-dom';
import SidebarV2 from '../components/SidebarV2';
import { useSidebarToggle } from '../common/SidebarToggleContext';
import { COLLAPSED, EXPANDED } from '../components/sidebar/sidebarNewStyles';

export default function Layout() {
    const { sidebarWidth } = useSidebarToggle()

    return (
        <div>
            <SidebarV2 />
            <div
                style={{
                    marginTop: '50px',
                    paddingTop: '30px',
                    paddingLeft: `${(sidebarWidth ? COLLAPSED : EXPANDED) + 10}px`,
                    width: 'calc(100% - 10px)',
                    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                }}
                id="main-content"
                className="mb-5"
            >
                <Outlet />
            </div>
        </div>
    );
}
